import React, { useState } from 'react';
const SelectedCourseItem = ({slno,course}) => {
  
  return (
    <div className='offeredcourseitemwithslnominusbg marginTopSmall bg-white '>
        <div className='offeredcourseitemslnocontainer bg-gray-200'>
            <div className='offeredcourseitemslno text-gray-900 font-semibold text-gray-900 font-semibold'>
              {slno}
            </div>
        </div>
        <div className='OfferedCourseItem'>
            <div className='OfferedCourseItemR1'>
                <div className='OfferedCourseItemR1C1'>
                    <div className='OfferedCourseItemCodeCover'>
                            <label className='OfferedCourseItemCodeLabel text-gray-900 text-gray-900'>CODE</label>
                            <label className='OfferedCourseItemCodeValue text-gray-900 font-semibold text-gray-900 font-semibold'>{course.code}</label>
                    </div>
                </div>
                <div className='OfferedCourseItemR1C2'>
                        <div className='OfferedCourseItemActionCover'>
                            
                        </div>
                </div>
            </div>
            <div className='OfferedCourseItemR2'>
                    <div className='OfferedCourseItemTitleCover'>
                            <label className='OfferedCourseItemCodeLabel text-gray-900 text-gray-900'>TITLE</label>
                            <label className='OfferedCourseItemCodeValue text-gray-900 font-semibold'>{course.title}</label>
                    </div>
            </div>
            <div className='OfferedCourseItemR3'>
                    <div className='OfferedCourseItemIPECrCover'>
                            <div className='OfferedCourseItemIPECrForType'>
                                <label className='OfferedCourseItemCodeLabel text-gray-900'>TYPE</label>
                                <label className='OfferedCourseItemCodeValue text-gray-900 font-semibold'>{course.type}</label>
                            </div>
                            <div className='OfferedCourseItemIPECr'>
                                <label className='OfferedCourseItemCodeLabel text-gray-900'>CRDT</label>
                                <label className='OfferedCourseItemCodeValue text-gray-900 font-semibold'>{course.credit}</label>
                            </div>
                            <div className='OfferedCourseItemIPECr'>
                                <label className='OfferedCourseItemCodeLabel text-gray-900'>I</label>
                                <label className='OfferedCourseItemCodeValue text-gray-900 font-semibold'>{course.i}</label>
                            </div>
                            <div className='OfferedCourseItemIPECr'>
                                <label className='OfferedCourseItemCodeLabel text-gray-900'>P</label>
                                <label className='OfferedCourseItemCodeValue text-gray-900 font-semibold'>{course.p}</label>
                            </div>
                            <div className='OfferedCourseItemIPECr'>
                                <label className='OfferedCourseItemCodeLabel text-gray-900'>E</label>
                                <label className='OfferedCourseItemCodeValue text-gray-900 font-semibold'>{course.e}</label>
                            </div>                            
                            
                    </div>
            </div>
        </div>
    </div>
  );
};

export default SelectedCourseItem;
